;(function (TrackOrder, $) {
  var $orderForm = $('.js-toggle-form'),
      $orderStatus = $('.js-set-status');

  var switchStatus = function(newClass,newTitle) {
    var $el = $orderForm.last(),
        baseClass = 'js-toggle-form toggle-form the-status '+ newClass,
        classList = $el.hasClass('is-active') ? 'is-active ' + baseClass : baseClass;

    $el.attr('class',classList).find('.heading-light').text(newTitle);
  };

  TrackOrder.setShipDate = function(date,trackingText,trackingURL) { //pass in false to reset
    var $orderStatus = $('.order-status'),
        now = new Date();

    if(date) {
      var days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ],
          weekday = days[date.getDay()],
          month = months[date.getMonth()],
          day = date.getDate();

      //set month day weekday
      $orderStatus.find('.arrival-weekday').text(weekday).next().text(month).parent().next().text(day);
      if (date < now) {
        $orderStatus.find('.heading-light').text('Shipped');
      } else {
        $orderStatus.find('.heading-light').text('Estimated Shipping');
      }

      $orderStatus.find('.tracking-number').html('<a href="' + trackingURL + '">' + trackingText + '</a>');
      $orderStatus.removeClass('no-status');
    } else {
      $orderStatus.addClass('no-status');
    }
  };

  TrackOrder.toggleForm = function(status) {
    if(typeof status !== undefined) {
      TrackOrder.setStatus(status);
    }
    $orderForm.toggleClass('is-active');
  };

  TrackOrder.setStatus = function(status) {
    switch(status) {
      case 'in-production':
        switchStatus('is-in-production','In Production');
        break;

      case 'shipped':
        switchStatus('is-shipped','Shipped');
        break;

      case 'delivered':
        switchStatus('is-delivered','Delivered');
        break;

      case 'backordered':
        switchStatus('is-backordered','In the Queue');
        break;
    }
  };

}(window.TrackOrder = window.TrackOrder || {}, jQuery, undefined));